import {FormValue, Translation} from '@brunata-angular/util';
import {EventAlarmFilterFormGroup} from '../event-alarm.model';

export type ColumnHeader = {
    labelTranslation?: Translation;
    columnKey: keyof FormValue<EventAlarmFilterFormGroup>;
    formType: 'text' | 'selectMultiple' | 'dateTime';
};

export const EVENT_ALARM_TABLE_COLUMNS: ColumnHeader[] = [
    {
        labelTranslation: {
            key: 'common_configuration-status',
        },
        columnKey: 'meterModelCriteriaMismatch',
        formType: 'selectMultiple',
    },
    {
        labelTranslation: {
            key: 'monitoring_alarm-name',
        },
        columnKey: 'alarmName',
        formType: 'text',
    },
    {
        labelTranslation: {
            key: 'event-alarms_EventType',
        },
        columnKey: 'eventTypeId',
        formType: 'selectMultiple',
    },
    {
        labelTranslation: {
            key: 'onlineReportingCostMail_type',
        },
        columnKey: 'vendorModels',
        formType: 'selectMultiple',
    },
];
